import React from 'react'
import Dialog from 'components/dialog'
import Button from 'components/button'
import { useSlidingSession } from 'hooks/session'
import { useAuth } from 'hooks/auth'

const formatSeconds = (total: number | null): string => {
  if (total == null) return ''
  const minutes = Math.floor(total / 60)
  const seconds = total % 60
  return `${minutes}:${seconds.toString().padStart(2, '0')}`
}

const SessionTimeoutModal: React.FC = () => {
  const { showWarningModal, secondsUntilExpiry, handleRemainSignedIn } = useSlidingSession()
  const { logout } = useAuth()

  if (!showWarningModal) return null

  const countdown = formatSeconds(secondsUntilExpiry)

  // A Radix dialog, so it stacks above any dialog already open: under one, it couldn't be seen or answered.
  return (
    <Dialog
      open={showWarningModal}
      onOpenChange={() => {}}
      dismissible={false}
      width="small"
      title="Are you still there?"
      footer={
        <>
          <Button internalType="danger" onClick={() => logout()}>
            Sign Out Now
          </Button>
          <Button internalType="accept" onClick={handleRemainSignedIn}>
            Stay Signed In
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-4">
        <p>
          You will be signed out in <strong>{countdown}</strong> due to inactivity.
        </p>
        <p>If you’re still working, choose “Stay signed in” to extend your session.</p>
      </div>
    </Dialog>
  )
}

export default SessionTimeoutModal
